import React from 'react';
import { Slider } from '@/components/ui/slider';
import { Label } from '@/components/ui/label';

interface ToneSliderProps {
  value: string;
  onChange: (tone: string) => void;
}

const tones = ['professional', 'casual', 'urgent'];

export const ToneSlider: React.FC<ToneSliderProps> = ({ value, onChange }) => {
  const idx = tones.indexOf(value);
  const sliderValue = idx >= 0 ? idx * 50 : 0;

  const handleChange = (val: number[]) => {
    const i = Math.round(val[0] / 50);
    onChange(tones[Math.min(i, tones.length - 1)]);
  };

  return (
    <div className="space-y-2">
      <Label className="text-xs">Tone: <span className="capitalize font-semibold text-primary">{value}</span></Label>
      <Slider value={[sliderValue]} onValueChange={handleChange} max={100} step={50} className="w-40" />
      <div className="flex justify-between text-[10px] text-muted-foreground w-40">
        <span>Professional</span>
        <span>Casual</span>
        <span>Urgent</span>
      </div>
    </div>
  );
};
